var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "periodic-billing" },
    [
      _vm.loadingData
        ? _c("SpinnerLayerComponent", { staticClass: "spinner-layer" })
        : _vm._e(),
      _vm.formSchema
        ? _c("FormGeneratorComponent", {
            attrs: {
              schema: _vm.formSchema,
              fieldValues: _vm.formData,
              context: _vm.context,
              permissionsEntity: _vm.permissionsEntity,
            },
            on: { saveFormData: _vm.onChangeFormFieldValue },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }